import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getHizmetler = () => api.get('/hizmetler/');
export const getHakkimizda = () => api.get('/hakkimizda/');
export const getYorumlar = () => api.get('/yorumlar/');
export const getSiteBilgileri = () => api.get('/site-bilgileri/');
export const postIletisim = (data) => api.post('/iletisim/', data);
export const postRandevu = (data) => api.post('/randevu/', data);
export const getLightbox = () => api.get('/lightbox/');

export default api;
